var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",class:[_vm.circle ? _vm.customClass : '']},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","aria-labelledby":_vm.name,"role":"presentation"}},[_c('g',{style:({'fill': _vm.fillColor})},[_c(_vm.icon,{tag:"component"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }